import { imageMimeTypes } from "./utils/imageMimeTypes.js";
import { getChartsLocalization } from "./utils/getChartsLocalization.js";

// This object is not Partial<ChartsLocaleText> because it is the default values

export const enUSLocaleText = {
  /* Overlay */
  loading: 'Loading data…',
  noData: 'No data to display',
  /* Toolbar */
  zoomIn: 'Zoom in',
  zoomOut: 'Zoom out',
  toolbarExport: 'Export',
  /* Toolbar Export Menu */
  toolbarExportPrint: 'Print',
  toolbarExportImage: mimeType => `Export as ${imageMimeTypes[mimeType] ?? mimeType}`
};
export const DEFAULT_LOCALE = enUSLocaleText;
export const enUS = getChartsLocalization(enUSLocaleText);